/* eslint-disable @typescript-eslint/no-explicit-any */
import { InlineErrorMessage } from "@components/atoms/Errors/InlineErrorMessage";
import Select from "react-select";

export type SelectOption = {
  label: string;
  value: string;
};

export type CustomSelectProps = {
  inlineerrormessage?: string;
  options: SelectOption[];
  className?: string;
  selectedOption?: {
    label: string;
    value: string;
  };
  title: string;
   
  onChange?: (value: any) => void;
  placeholderText: string | null;
  id: string;
};

const customStyles = {
  singleValue: (provided: any) => ({
    ...provided,
    color: 'text-brand',
    fontWeight: 600 
  }),
};
export const SelectInput = (props: CustomSelectProps) => {
  return (
    <div className="body-1 my-2 max-w-lg gap-y-6 text-brand">
      <div className="mb-6 text-2xl font-semibold text-brand">{props.title}</div>
      <InlineErrorMessage message={props.inlineerrormessage} />
      <Select
        options={props.options}
        styles={customStyles}
        value={props.selectedOption}
        onChange={props.onChange}
        tabSelectsValue={true}
        placeholder={props.placeholderText}
        aria-label={props.id}
      />
    </div>
  );
};

SelectInput.displayName = "SelectInput";
